import { render } from "./EmptyContent.vue?vue&type=template&id=793046c3&ts=true"
import script from "./EmptyContent.vue?vue&type=script&lang=ts"
export * from "./EmptyContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__